import React from 'react';
import Radium from 'radium';
import {Container} from 'flux/utils';
import {Helmet} from "react-helmet";

import HeaderContainer from 'containers/HeaderContainer';
import OrderListContainer from 'containers/OrderListContainer';

import OrderStore from 'stores/OrderStore';
import AppConstants from 'AppConstants';

import HttpService from 'service/HttpService';
import SessionStore from 'stores/SessionStore';

import CacheService from 'service/CacheService';

import AdminDashboardTabs from 'views/admin/AdminDashboardTabs';

import Select from 'react-select';
import Footer from 'views/Footer';

const styles = {
			statContainer: {justifyContent: 'space-around', margin: '20px'},
			rowBox: {margin: "10px", cursor: 'pointer', flexGrow: '1', 
				textAlign: 'center', display: 'flex', flexDirection: 'column', background: '#eee',
				padding: '10px',
				':hover': {background: '#e0dede', color: 'white'},
				'@media (max-width: 700px)': {flex:'0 0 auto', padding: '0 5px'}
			}
}


const ORDER_STATE = AppConstants.ORDER_STATE;

const ORDER_STATES_DROPDOWN = [ORDER_STATE.ORDER_PLACED,
	ORDER_STATE.ORDER_CONFIRMED,
	ORDER_STATE.SHIPPING,
	ORDER_STATE.DELIVERED,
	ORDER_STATE.CANCELLED,
	ORDER_STATE.DELIVERED_CLOSED];


class EachBox extends React.Component {
	onBoxClick() {
		this.props.onClick(this.props.orderState);
	}

	render() {
		const title = this.props.title;
		const value = this.props.value;

		let boxStyle = [styles.rowBox];

		if(this.props.style)
			boxStyle.push(this.props.style);

		const valueStyle = [{margin: '0px', color: '#555', fontSize: '125%'}];

		if(this.props.highlightValue && value > 0)
			valueStyle.push({color: '#f89319', fontWeight: 'bolder'});
		
		return <span style={boxStyle} onClick={this.onBoxClick.bind(this)}>
			<span style={{margin: '5px', color: '#999', fontSize: '120%'}}>{title}</span>
			<span style={valueStyle}>{value}</span>
		</span>
	}
}

EachBox = Radium(EachBox);


const LAST_FETCHED_ORDER = "last_fetched_order";

class OrderDashboardContainer extends React.Component {

	static getStores() {
		return [OrderStore];
	}


	static calculateState(prevState) {
		return {
			orderStat: OrderStore.getOrderStat()
		}
	}

	constructor(props) {
		super(props);

		const currentSession = SessionStore.getCurrentSession();
		let defaultOrderType = AppConstants.ORDER_STATE.ORDER_PLACED.value;

		if(currentSession && currentSession.user.permissions && currentSession.user.permissions.indexOf("shipping_orders_only") >= 0)
			defaultOrderType = AppConstants.ORDER_STATE.SHIPPING.value;

		if(CacheService.get(LAST_FETCHED_ORDER))
			defaultOrderType = CacheService.get(LAST_FETCHED_ORDER);

		this.state = {orderState: defaultOrderType};
		this.onOrderStateChange = this.onOrderStateChange.bind(this);
	}


	componentDidMount() {
		const session = SessionStore.getCurrentSession();

		if(session) {
			const user = session.user;
			const userType = user.userType;
			if(userType === AppConstants.USER_TYPE.ADMIN || userType === AppConstants.USER_TYPE.SALES)
				HttpService.getOrderStat();
		}
	}

	onOrderStateChange(newState) {
		if(newState) {
			CacheService.save(LAST_FETCHED_ORDER, newState.value);
			this.setState({orderState: newState.value})
		}
	}

	render() {
		const orderStat = this.state.orderStat;
		
		return (
				<div>
					<Helmet>
                    	<title>Order Dashboard | Seto Canvas</title>
                	</Helmet>
					<HeaderContainer />
					<AdminDashboardTabs active="orders">
						{
							orderStat && 
							<div style={{margin: '20px'}}>
								<div className="flexRow" style={styles.statContainer}>
									<EachBox title="Order Placed" highlightValue={true} value={orderStat.placed || 0} orderState={ORDER_STATE.ORDER_PLACED} onClick={this.onOrderStateChange} />
									<EachBox title="Order Confirmed" value={orderStat.confirmed || 0} orderState={ORDER_STATE.ORDER_CONFIRMED} onClick={this.onOrderStateChange} />
									<EachBox title="Order Shipping" value={orderStat.shipping || 0} orderState={ORDER_STATE.SHIPPING} onClick={this.onOrderStateChange} />
									<EachBox title="Order Delivered" value={orderStat.delivered || 0} orderState={ORDER_STATE.DELIVERED} onClick={this.onOrderStateChange} />
									<EachBox title="Order Cancelled" value={orderStat.cancelled || 0} orderState={ORDER_STATE.CANCELLED} onClick={this.onOrderStateChange} />
								</div>
							</div>
						}
						

						<div className="mainContainer">
							<div style={{width: '40%', '@media (max-width: 770px)': {width: '100%'}}}>
								<h3 style={{margin: '0 10px 0 0'}}>Order Type</h3>

								<Select onChange={this.onOrderStateChange} value={this.state.orderState} 
										options={ORDER_STATES_DROPDOWN} clearable={false}
										style={{flexGrow: '1', margin: '0'}}/>	
							</div>

							<OrderListContainer showPaymentOption={false} orderState={this.state.orderState} showProductInfo={true} changeOrderState={true} showExportAsCSV={true} />
						</div>
					
					</AdminDashboardTabs>
				
					<Footer />
				</div>
			);
		
	}

}

export default Radium(Container.create(OrderDashboardContainer));


// WEBPACK FOOTER //
// ./src/containers/OrderDashboardContainer.js